import React, { useEffect, useState } from 'react'
import { Button } from 'components/elements/index.js'
import { Columns } from 'components/elements'
import { apiProcess } from './../../api/api.js'
import './reviews.css'

const PaginateArrayWrap = (props) => {
  const [arrayView, setArrayView] = useState([])
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(props.pageLimit)

  useEffect(() => {
    if (props.data?.length <= pageLimit) {
      //if we don't have enough to paginate, just stuff it in state
      setArrayView(props.data)
      setLoading(false)
    } else {
      getData()
    }
  }, [])

  const getData = () => {
    setLoading(true)
    setPage(page + 1)
    const url = `motorcycles/${props.bikeId}/reviews?page=${page +
      1}&page_count=5`
    apiProcess(url, false, 'bike-reviews', 'Bike Reviews ' + url)
      .then(function(reviews) {
        setArrayView([...arrayView, ...reviews])
        setLoading(false)
      })
      .catch(function(errorResponse) {})
  }

  return (
    <span className="review-container">
      {arrayView?.length > 0 && (
        <>
          {arrayView.map((item, index) => (
            <>{props.render({ item, index })}</>
          ))}
        </>
      )}
      {loading && (
        <Columns.Column size={12}>
          <div className="has-text-centered">
            <i className="fas fa-3x fa-cog fa-spin review-spinner"></i>
          </div>
        </Columns.Column>
      )}
      {arrayView?.length < pageLimit / 2 && !loading && (
        <div
          className="has-text-centered is-block mt-6"
          style={{ width: '100%' }}
        >
          <Button color="primary" outlined onClick={() => getData()}>
            {props.buttonText}
          </Button>
        </div>
      )}
      {arrayView.length === 0 && <>{props.noResultsRender}</>}
    </span>
  )
}

export default PaginateArrayWrap

PaginateArrayWrap.defaultProps = {
  buttonText: 'missing button text',
  noResultsRender: <div>No results.</div>,
  render: <div>missing render element</div>,
  pageLimit: 5,
  data: [],
}
